import { API_URL } from "../config/constants";

const keyCache = {};
const keyPromiseCache = {};

const findStringValueDeep = (payload, requestedKey) => {
    if (!payload || typeof payload !== "object") {
        return "";
    }

    const normalizedKeyName = requestedKey.toLowerCase();
    const priorityKeys = [
        "value",
        "keyValue",
        "keyvalue",
        requestedKey,
        normalizedKeyName,
        "apiKey",
        "apikey",
        "googleAPIKey",
        "googleapikey",
        "key",
        "secret",
    ];

    for (const key of priorityKeys) {
        if (typeof payload[key] === "string") {
            return payload[key];
        }
    }

    const entries = Object.entries(payload);
    if (entries.length === 1 && typeof entries[0][1] === "string") {
        return entries[0][1];
    }

    for (const [, value] of entries) {
        if (typeof value === "string") {
            continue;
        }

        const nested = findStringValueDeep(value, requestedKey);
        if (nested) {
            return nested;
        }
    }

    return "";
};

const parseKeyResponse = (payload, requestedKey) => {
    if (typeof payload === "string") {
        return payload;
    }

    if (!payload || typeof payload !== "object") {
        return "";
    }

    return findStringValueDeep(payload, requestedKey);
};

const fetchRuntimeKey = async keyName => {
    if (keyCache[keyName] !== undefined) {
        return keyCache[keyName];
    }

    if (!keyPromiseCache[keyName]) {
        const url = `${API_URL}/getApiKey?keyName=${encodeURIComponent(keyName)}`;

        keyPromiseCache[keyName] = fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json, text/plain, */*",
            },
        })
            .then(async response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch runtime key '${keyName}'`);
                }

                const contentType = response.headers.get("content-type") || "";
                const payload = contentType.includes("application/json") ? await response.json() : await response.text();

                const value = parseKeyResponse(payload, keyName);
                keyCache[keyName] = value;
                return value;
            })
            .catch(() => {
                keyCache[keyName] = "";
                return "";
            })
            .finally(() => {
                delete keyPromiseCache[keyName];
            });
    }

    return keyPromiseCache[keyName];
};

export const getRuntimeApiKey = async () => await fetchRuntimeKey("apiKey");

export const getRuntimeGoogleApiKey = async () => await fetchRuntimeKey("googleAPIKey");
